import { render, staticRenderFns } from "./TCategories.vue?vue&type=template&id=5509113b&scoped=true&"
import script from "./TCategories.vue?vue&type=script&lang=js&"
export * from "./TCategories.vue?vue&type=script&lang=js&"
import style0 from "./TCategories.vue?vue&type=style&index=0&id=5509113b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5509113b",
  null
  
)

export default component.exports